import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type WorkOrdersQueryListItem = ResultOf<
  typeof workOrderListQuery
>["workOrders"]["data"][number];

export const workOrderListQuery = graphql(`
  query WorkOrderList(
    $search: String
    $supplier_id: ID
    $relocation_id: ID
    $page: Int!
    $first: Int!
    $status: [WorkOrderStatus!]
    $where: QueryWorkOrdersWhereWhereConditions
    $whereAssignments: QueryWorkOrdersWhereAssignmentsWhereHasConditions
    $orderBy: [QueryWorkOrdersOrderByRelationOrderByClause!]
  ) {
    workOrders(
      search: $search
      supplier_id: $supplier_id
      relocation_id: $relocation_id
      page: $page
      first: $first
      status: $status
      where: $where
      whereAssignments: $whereAssignments
      orderBy: $orderBy
    ) {
      data {
        id
        status
        reference
        vehicle_type
        created_at
        depart_after
        manifest_url
        supplier {
          id
          name
          ...SupplierIconFields
        }
        departureAddress {
          city
        }
        deliveryAddress {
          city
        }
        number_of_drivers
        assignments {
          id
          proDriver {
            id
            name
            user {
              profilePicture {
                ...MediaFields
              }
            }
          }
        }
        currentQuote {
          id
          reference
          currency
          amount_exc_tax
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export type WorkOrderRecord = NonNullable<
  ResultOf<typeof workOrderRecordQuery>["workOrder"]
>;

export const workOrderRecordQuery = graphql(`
  query WorkOrder($id: ID!) {
    workOrder(id: $id) {
      ...WorkOrdersFields

      currentQuote {
        ...QuoteRecordFields
        ...QuoteActionFields
      }
    }
  }
`);

graphql(`
  fragment WorkOrdersFields on WorkOrder {
    id
    vehicle_type
    admin_notes
    status
    reference
    currency
    depart_after
    deliver_before
    description
    number_of_drivers
    has_return_trip
    is_service_center
    invoice_not_required
    manifest_url
    supplier_thread_id

    acceptedOfferCount

    notificationSettings {
      id
      type
      email
    }

    adminAssignees {
      id
      name
    }

    assignments {
      ...WorkOrderAssignmentFields
      review {
        id
      }
      payouts {
        id
        status
        paid_at
      }
      proDriver {
        id
        user_id
        name
        email
        phone
        date_of_birth
        license_type
        license_number
        license_issuer
        numberOfCompletedAssignments
        rating
        bank_name
        bank_account_name
        bank_account_number
        bank_identifier_code
        user {
          id
          profilePicture {
            ...MediaFields
          }
        }
      }
      latestLocation {
        id
        latitude
        longitude
        recorded_at
      }
      activeProDriverAgreement {
        id
        title
        status
      }
    }

    supplier {
      name
      id
      ...SupplierIconFields
      tax_type
      is_tax_included
      billingEntity {
        id
        name
      }
      managedBy {
        id
        name
      }
      ...SupplierIconFields
    }

    currentInvoice {
      id
      uuid
      reference
      status
      currency
      amount_exc_tax
      amount_inc_tax
      invoice_date
      due_date
      purchase_order_number
      created_at
      updated_at
      managedBy {
        id
        name
      }
      payee {
        id
        name
      }
    }

    departureAddress {
      ...AddressFields
    }
    deliveryAddress {
      ...AddressFields
    }

    relocation {
      id
      reference
    }

    created_at
  }
`);
